import React, { useContext, useEffect, useState } from 'react'
import { AdvertiserPrimaryButton } from '../commonComponents/AdvertiserPrimaryButton'

import { AdvertiserHeader } from '../commonComponents/AdvertiserHeader'
import { SharedContext } from '../context/SharedContext'

const CommonComponent = ({
  title,
  description,
  onClick,
  buttonTitle,
  buttonClassName,
  containerClassName
}) => {
  return (
    <div className="m-[16px] font-noto-sans sm:flex sm:justify-between">
      <div className="flex flex-col items-center sm:items-start">
        <div className="text-md font-bold leading-[21.79px] text-[#191919]">{title}</div>
        <div className="mt-[2px] mb-[12px] text-sm font-normal leading-[16.34px] text-[#666666]">
          {description}
        </div>
      </div>
      <AdvertiserPrimaryButton
        {...{ onClick, extraClassName: buttonClassName, containerClassName }}
        title={buttonTitle}
        isArrowPresent={false}
      />
    </div>
  )
}

const Error = () => {
  const { loginDetails, location } = useContext(SharedContext)
  const [hydration, setHydrated] = useState(true)

  const navigateToLogin = () => {
    window?.open(process.env.NEXT_PUBLIC_APP_URL + 'hire/login', '_self')
  }

  const navigateToPostJob = () => {
    // setpostJobPresentStep(1)
    if (!loginDetails?.isLogIn) navigateToLogin()
    else window?.open(process.env.NEXT_PUBLIC_APP_URL + 'hire/post-job', '_self')
  }

  const navigateToJobListingFromAdvertiser = () => {
    // setBody({ apiBody: {}, selectedOptions: {} })
    if (location) {
      window?.open(
        process.env.NEXT_PUBLIC_APP_URL +
          `jobs/${(location?.name || location?.title).toLowerCase()}`,
        '_self'
      )
    } else {
      window?.open(process.env.NEXT_PUBLIC_APP_URL + 'jobs', '_self')
    }
  }

  useEffect(() => {
    setHydrated(false)
  }, [])

  if (hydration) return

  return (
    <div className="h-[100vh] bg-[#F7F7F7]">
      <div className="flex  flex-col items-center space-y-[32px]  p-24 font-noto-sans md:space-y-[48px]">
        <div className="flex flex-col items-center">
          <div className="text-md font-bold leading-[25.6px] text-[#333436] md:text-[32px] md:leading-[40px]">
            Page not found
          </div>
          <div className="mt-[12px] text-center text-sm font-normal leading-[19.2px] text-[#66676B] md:mt-[4px] md:text-md md:leading-[25.6px]">
            Please make sure the URL is correct, or try the links below.
          </div>
        </div>
        <div className="w-full rounded-[10px] border-[1px] border-solid border-[#404040] bg-white sm:w-[590px]">
          <div className="border-[0px] border-b-[1px] border-solid border-[#404040]">
            <CommonComponent
              {...{
                title: 'Want to hire?',
                description: 'Submit your first job Ad post for free.',
                onClick: navigateToPostJob,
                buttonTitle: 'Post job',
                buttonClassName: 'border-[0px] hover:border-[0px] bg-secondary',
                containerClassName: 'w-full sm:w-[182px]'
              }}
            />
          </div>
          <CommonComponent
            {...{
              title: 'Want a job?',
              description: 'Apply to latest job openings.',
              onClick: navigateToJobListingFromAdvertiser,
              buttonTitle: 'Search jobs',
              containerClassName: 'w-full sm:w-[135px]',
              buttonClassName:
                'bg-[#FFF1CC] border-solid border-[1px] border-[#FFBB00] hover:border-solid hover:border-[1px]'
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default Error
